<app-loader id="header-loader" />
<header
  class="h-fit bg-white border-b border-slate-200 flex items-center justify-between p-4 sticky top-0 z-10"
>
  <div class="flex gap-4 items-center">
    <p-button icon="pi pi-bars" class="block 2xl:hidden" (click)="toggleSidebar.emit()" />
    <div class="flex gap-2 items-center">
      @if (headerService.title()) {
      <h1 class="text-xl font-semibold text-slate-800">{{ headerService.title() }}</h1>
      } @if(headerService.subTitle()) { -
      <span class="text-slate-700 text-xl">{{ headerService.subTitle() }}</span>
      }
    </div>
  </div>

  <div class="flex items-center justify-center">
    <div
      class="group flex items-center gap-4 border-none bg-transparent outline-none cursor-pointer p-0"
    >
      <button type="button" (click)="menu.toggle($event)">
        <div
          class="flex items-center gap-3 border border-gray-300 p-1.5 pr-4 rounded-full transition-all"
        >
          <div class="relative flex">
            <p-avatar
              icon="pi pi-user"
              shape="circle"
              class="w-10 h-10 bg-white text-slate-400 border border-white shadow-sm"
            />
            <span
              class="absolute bottom-0 right-0 block w-2.5 h-2.5 bg-emerald-500 border border-gray-300 rounded-full"
            ></span>
          </div>

          <i class="pi pi-chevron-down text-slate-500 text-sm"></i>
        </div>
      </button>
    </div>
  </div>
</header>

<p-menu
  #menu
  [model]="userMenuItems()"
  [popup]="true"
  [style]="{ 'transform-origin': 'right' }"
  styleClass="m-2 min-w-36 shadow-2xl border border-slate-100 menu-right"
/>
